"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsWelcomeLoginRecoveryControl = void 0;
const M = require("materialize-css");
const DOM_1 = require("../../../../../../public/js/utils/DOM");
const FormValidator_1 = require("../../../../../../public/js/utils/Validator/FormValidator");
const Form_1 = require("../../../../Form/Form");
var ControlsWelcomeLoginRecoveryControl;
(function (ControlsWelcomeLoginRecoveryControl) {
    class Config {
        static recoveryFormId = "frm-recovery-recoveryForm";
        static recoveryFormSubmitId = "buttonRecovery";
        static recoveryControl = "recovery";
        static recoveryCallBack = "RecoveryPassword";
    }
    class Control {
        static load() {
            this.triggerRecoveryForm();
        }
        static triggerRecoveryForm() {
            const formElement = DOM_1.DOM.Parser.getHtmlElement(Config.recoveryFormId);
            const recoveryButton = DOM_1.DOM.Parser.getHtmlElement(Config.recoveryFormSubmitId);
            FormValidator_1.FormValidator.validateForm({ form: formElement, forceSubmitButton: recoveryButton });
            M.updateTextFields();
            recoveryButton.addEventListener('click', (event) => {
                void Form_1.ControlsForm.Controller.sendFormDataRequest(formElement, {
                    linkParameters: { component: Config.recoveryControl, method: Config.recoveryCallBack, parameters: [] },
                    formData: Form_1.ControlsForm.Controller.getFormData(formElement),
                    forceDisabledButtons: [recoveryButton],
                    event: event,
                    snippetCallback: () => {
                        this.triggerRecoveryForm();
                    }
                });
            });
        }
    }
    ControlsWelcomeLoginRecoveryControl.Control = Control;
})(ControlsWelcomeLoginRecoveryControl || (exports.ControlsWelcomeLoginRecoveryControl = ControlsWelcomeLoginRecoveryControl = {}));
